import React from 'react';
// styles
import styled from 'styled-components';

const SettingsIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Settings"
    className={className}
  >
    <path d="M9.99996 5.41667C11.4957 5.41667 12.7083 4.2041 12.7083 2.70833C12.7083 1.21256 11.4957 0 9.99996 0C8.50419 0 7.29163 1.21256 7.29163 2.70833C7.29163 4.2041 8.50419 5.41667 9.99996 5.41667Z" />
    <path d="M9.99996 12.7082C11.4957 12.7082 12.7083 11.4956 12.7083 9.99984C12.7083 8.50407 11.4957 7.2915 9.99996 7.2915C8.50419 7.2915 7.29163 8.50407 7.29163 9.99984C7.29163 11.4956 8.50419 12.7082 9.99996 12.7082Z" />
    <path d="M9.99996 20.0002C11.4957 20.0002 12.7083 18.7876 12.7083 17.2918C12.7083 15.7961 11.4957 14.5835 9.99996 14.5835C8.50419 14.5835 7.29163 15.7961 7.29163 17.2918C7.29163 18.7876 8.50419 20.0002 9.99996 20.0002Z" />
  </svg>
);

export default styled(SettingsIcon)``;
